<template>
  <el-tabs v-model="activeName" class="tabs">
    <el-tab-pane name="first" label="电脑端" class="mineCon">
      <div class="help">
        <p><strong>第一步：</strong>① 登录状态下，点击右上角头像，在下拉菜单中点击<span class="orange">【我的预约】</span>按钮，进入【预约列表页面】<br/>
          ② 找到即将咨询的预约条目，点击<span class="orange">【去咨询】</span>按钮，进入【通话页面】
        </p>
        <img src="../../../assets/img/userAppoint_f.png" alt="" width="906">
        <p><strong>第二步：</strong>在【通话】页面，请耐心等待医生呼叫，医生呼叫时会出现【邀请通话】弹窗，点击<span class="orange">【接听】</span>图标接收通话
        </p>
        <img src="../../../assets/img/userAppoint_g.png" alt="">
        <p><strong>咨询设备设置：</strong>开启视频需要浏览器获取设备权限, 当提示【是否允许获取麦克风、摄像头权限】时,请选择【允许】， 如【拒绝】将无法正常使用视频、语音等功能</p>
        <img src="../../../assets/doctorImg/consultation_a.png" alt="">
        <p>如未显示，需重置麦克风、摄像头权限。以Chrome为例，设置步骤如下</p>
        <p><strong>第一步：</strong>在【Chrome】浏览器中，找到【设置】</p>
        <img src="../../../assets/doctorImg/consultation_b.png" alt="" height="355">
        <p><strong>第二步：</strong>在【设置】页面，选中左边菜单栏中的<span class="orange">【隐私设置和安全性】</span>，点击<span
            class="orange">【网站设置】</span></p>
        <p>近期活动中如有域名 <span class="orange">www.neuropsychstudio.com</span>，打开后点击【重置权限】</p>
        <img src="../../../assets/doctorImg/consultation_c.png" alt="" height="226">
        <img src="../../../assets/doctorImg/consultation_d.png" alt="">
        <img src="../../../assets/doctorImg/consultation_e.png" alt="">
      </div>
    </el-tab-pane>
    <el-tab-pane name="second" label="移动端" class="mineCon">
      <div class="help">
        <div class="flex userPh mt_20">
          <p><strong>第一步：</strong>在【菜单栏】中<span class="orange">【我的预约】</span>按钮</p>
          <p><strong>第二步：</strong>在【预约列表】中点击<span class="orange">【去咨询】</span></p>
          <p><strong>第三步：</strong>使用【微信APP】，识别<span class="orange">【心理亦笙】</span>小程序二维码</p>
        </div>
        <img src="../../../assets/img/userAppointRes_c.png" alt="">
        <div class="flex userPh mt_20">
          <p><strong>第四步：</strong>进入【亦笙工作室】微信小程序中，填写登录信息，点击<span class="orange">【登录】</span>按钮</p>
          <p><strong>第五步：</strong>在【待通话列表】中，点击<span class="orange">【通话】</span>按钮，进入通话页面</p>
          <p><strong>【医生未就绪状态】：</strong>请耐心等待医生呼叫</p>
        </div>
        <img src="../../../assets/img/userAppointRes_d.png" alt="">
        <p><strong>【通话状态】</strong></p>
        <div class="flex">
          <img src="../../../assets/img/userAppointRes_e.png" alt="" width="34%">
          <div class="mt_50">
            <div class="mt_20">【视频通话】<br/>进入咨询等待页面后，请耐心等待用户的应答</div>
            <div class="mt_20">【文字聊天】<br/>视频下方有文字聊天框，可发送图片，协助咨询交流</div>
          </div>
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>

</template>

<script>
export default {
  name: "consulting",
  data() {
    return {activeName: 'first'}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/help";
</style>
